import { get, postJson } from '../httpClient';

/**
 * Clients for the org-side and creator-side assignment endpoints.
 *
 * Org-scoped:  /api/org/:orgId/assignments/*
 *   (gated by ASSIGN_CREATORS for writes; any member can list)
 *
 * Creator-scoped: /api/creator/assignments/*
 *   (self-scoped via SDK session — no userId in path)
 */

export const assignmentsAPI = {
  // ── Org side ──
  /** GET /api/org/:orgId/assignments */
  listForOrg: orgId => get(`/api/org/${orgId}/assignments`),

  /** POST /api/org/:orgId/assignments */
  createForOrg: (orgId, body) => postJson(`/api/org/${orgId}/assignments`, body),

  /** POST /api/org/:orgId/assignments/:assignmentId/revoke */
  revokeForOrg: (orgId, assignmentId) =>
    postJson(`/api/org/${orgId}/assignments/${assignmentId}/revoke`),

  /** GET /api/org/:orgId/assignments/creator/:creatorId/live-rooms */
  listCreatorLiveRooms: (orgId, creatorId) =>
    get(`/api/org/${orgId}/assignments/creator/${creatorId}/live-rooms`),

  /** GET /api/org/:orgId/insights/rented — bulk rented-data overlay for the Insights page */
  getRentedInsights: orgId => get(`/api/org/${orgId}/insights/rented`),

  /** GET /api/org/:orgId/calendar/rented-episodes — episodes from assigned Live Rooms */
  getRentedEpisodes: orgId => get(`/api/org/${orgId}/calendar/rented-episodes`),

  // ── Creator side ──
  /** GET /api/creator/assignments */
  listForCreator: () => get('/api/creator/assignments'),

  /** POST /api/creator/assignments/:assignmentId/accept */
  accept: (assignmentId, body) =>
    postJson(`/api/creator/assignments/${assignmentId}/accept`, body),

  /** POST /api/creator/assignments/:assignmentId/reject */
  reject: (assignmentId, body) =>
    postJson(`/api/creator/assignments/${assignmentId}/reject`, body),

  /** POST /api/creator/assignments/:assignmentId/revoke */
  revoke: assignmentId =>
    postJson(`/api/creator/assignments/${assignmentId}/revoke`),
};
